import { BetEventDto, MintedNFTEventDto, NewMessageEventDto, PurchasedLootboxEventDto } from '../contract';

export function mapRawToPurchasedLootboxEventDto(raw: any): PurchasedLootboxEventDto {
	return {
		lootboxId: raw.lootbox_id,
		purchasedLootboxId: raw.purchased_lootbox_id,
		buyer: raw.buyer,
	};
}

export function mapRawToNewMessageEventDto(raw: any): NewMessageEventDto {
	return {
		roomId: raw.room_id,
		author: raw.author,
		message: raw.text,
		timestamp: +raw.timestamp,
	};
}

export function mapRawToBetEventDto(raw: any, txId?: string): BetEventDto {
	return {
		betId: raw.bet_id,
		amount: raw.amount,
		gambler: raw.gambler,
		reward: typeof raw.reward === 'string' ? Number(raw.reward) : raw.reward,
		win: typeof raw.win === 'string' ? raw.win === 'true' : Boolean(raw.win),
		txId,
		stake: raw.stake != null ? Number(raw.stake) : raw.amount != null ? Number(raw.amount) : undefined,
		coinType: raw.coin_type ?? raw.coinType ?? undefined,
		payoutMultiplier:
			raw.payout_multiplier?.pos0 != null
				? Number(raw.payout_multiplier.pos0) / 2 ** 32
				: raw.payout_multiplier != null
					? Number(raw.payout_multiplier)
					: undefined,
	};
}

export function mapRawToMintedNftEvent(raw: any, digest: string): MintedNFTEventDto {
	return {
		object_id: raw.object_id,
		creator: raw.creator,
		name: raw.name,
		digest,
	};
}
